import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ActivitiesPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const activitiesPanelEntryPoint: EntryPoint<ActivitiesPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ActivitiesPanelEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-proactive-support-activities-panel" */ './ActivitiesPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
